// extracted by mini-css-extract-plugin
module.exports = {"suggestions-container":"suggestions-container_suggestions-container__PkT1W","suggestions-container__selected":"suggestions-container_suggestions-container__selected__TQTIL"};